import { render, staticRenderFns } from "./ESGModuleMachineWiseTable.vue?vue&type=template&id=5a0c1376"
import script from "./ESGModuleMachineWiseTable.vue?vue&type=script&lang=js"
export * from "./ESGModuleMachineWiseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports